import React from 'react';
import { DeleteWithConfirmButton, useRecordContext, useTranslate } from 'react-admin';

export const BrandDeleteWithConfirmButton: React.FC<any> = (props) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const modelCount = (record as any)?.model_count ?? 0;

    const confirmContent =
        modelCount > 0
            ? translate('resources.vehicle-brands.delete.cascadeWarning', {
                  _: `This will also delete ${modelCount} model(s) belonging to this brand. This cannot be undone.`,
                  count: modelCount,
              })
            : translate('resources.vehicle-brands.delete.noModels', {
                  _: 'This brand has no models. Deletion cannot be undone.',
              });

    return (
        <DeleteWithConfirmButton
            confirmTitle={translate('resources.vehicle-brands.delete.title', {
                _: 'Delete brand?',
            })}
            confirmContent={confirmContent}
            {...props}
        />
    );
};
